import { MaskitoOptions } from '@maskito/core';

import { maskitoWithPlaceholder } from '@maskito/kit';

export default {
  ...maskitoWithPlaceholder('+7 (___) ___-__-__'),
  mask: ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
} as MaskitoOptions;
